import { render, staticRenderFns } from "./ads.vue?vue&type=template&id=312c67f3&scoped=true&"
import script from "./ads.vue?vue&type=script&lang=ts&"
export * from "./ads.vue?vue&type=script&lang=ts&"
import style1 from "./ads.vue?vue&type=style&index=1&id=312c67f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312c67f3",
  null
  
)

export default component.exports